import { ArrowBigUp } from 'lucide-react'
import * as React from 'react'

import { Button } from './button'

/** Icon-only unless given children, so it names itself — screen readers and AI agents get nothing from the arrow. */
export function SubmitButton({ children, ...props }: React.ComponentProps<typeof Button>) {
  return (
    <Button type="submit" size="icon" aria-label={children ? undefined : 'Next'} {...props}>
      {children ?? <ArrowBigUp />}
    </Button>
  )
}
